import { useState, useEffect } from "react";
import {
  degrees,
  IndexOutOfBoundsError,
  PDFDocument,
  rgb,
  StandardFonts,
} from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/template4.pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFontCondensed from "../assets/fonts/Roboto-BoldCondensed.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";
import { trackDownload } from "./analytics.js";

async function makeFlyerTemplateFour(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);
  // const licensingSplit = userData.brand.Licensing.slice(0, 30); // first line
  // const licensingSplit2 = userData.brand.Licensing.slice(30); // second line

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );

  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let branchLicense = userData.branch.Licensing;

  let licensingLineOne = userData.brand.licensingLineOne;
  let licensingLineTwo = userData.brand.licensingLineTwo;
  let licensingLineThree = userData.brand.licensingLineThree;
  let licensingLineFour = userData.brand.licensingLineFour;

  if (userData.flyerChoice.Spanish == true) {
    branchLicense = userData.branch.SpanishLicensing;
    licensingLineOne = userData.brand.SpanishlicensingLineOne;
    licensingLineTwo = userData.brand.SpanishlicensingLineTwo;
    licensingLineThree = userData.brand.SpanishlicensingLineThree;
    licensingLineFour = userData.brand.SpanishlicensingLineFour;
  }

  let nmmlNumberHeight = 579;
  let officeNumber = 568;
  let mobileNumberHeight = 557;
  let faxNumberHeight = 546;
  let emailHeight = 535;
  let mloWebsiteHeight = 524;

  if (userData.settings.user.mobileNumber === false) {
    faxNumberHeight = faxNumberHeight + 12;
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (userData.settings.user.faxNumber === false) {
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (
    userData.settings.user.headshot === true &&
    (userData.settings.user.mobileNumber === false ||
      userData.settings.user.faxNumber === false)
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  if (
    userData.settings.user.headshot === true &&
    userData.settings.user.mobileNumber === false &&
    userData.settings.user.faxNumber === false
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFontCondensed).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );
  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  // const minionFont = await pdfDoc.embedFont(fontBytesforMinion);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();

  if (userData.brand.hasHeader) {
    firstPage.drawRectangle({
      x: 0,
      y: 716,
      width: 612,
      height: 90,
      color: headerColor,
    });
  }

  if (userData.flyerChoice.Spanish == true) {
    firstPage.drawRectangle({
      x: 375,
      y: 641,
      width: 203,
      height: 45,
      color: ctaColor,
    });
    firstPage.drawText("LLAME A SU EQUIPO DE", {
      x: 445,
      y: 432.7,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText("FINANCIAMENTO DE VIVIENDAS HOY!", {
      x: 407.5,
      y: 415.5,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
  } else {
    firstPage.drawRectangle({
      x: 375,
      y: 641,
      width: 195,
      height: 45,
      color: ctaColor,
    });

    if (
      userData.flyerChoice.ctaLineOne !== "" &&
      userData.flyerChoice.ctaLineOne !== undefined &&
      userData.flyerChoice.ctaLineOne !== null
    ) {
      firstPage.drawText(`${userData.flyerChoice.ctaLineOne}`, {
        x: 414,
        y: 667,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      firstPage.drawText("CALL YOUR HOME", {
        x: 414,
        y: 667,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }

    if (
      userData.flyerChoice.ctaLineTwo !== "" &&
      userData.flyerChoice.ctaLineTwo !== undefined &&
      userData.flyerChoice.ctaLineTwo !== null
    ) {
      firstPage.drawText(`${userData.flyerChoice.ctaLineTwo}`, {
        x: 396,
        y: 650,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      firstPage.drawText("FINANCING TEAM TODAY!", {
        x: 396,
        y: 650,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }
  }

  firstPage.drawRectangle({
    x: 377,
    y: 600,
    width: 100,
    height: 0.3,
    color: rgb(0.5, 0.5, 0.5),
  });

  firstPage.drawText(`${person.FirstName.toUpperCase()}`, {
    x: width - 235,
    y: 620,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
    weight: "bold",
  });

  firstPage.drawText(`${person.LastName.toUpperCase()}`, {
    x: width - 235,
    y: 605,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
  });
  const textWidth = minionFont.widthOfTextAtSize(`${person.Title}`, 10);
  const trimmedTitle = person.Title.split(" ");
  let titleHeight = 590;
  let textHeight = 0;

  let emailYOffset = 0;

  if (
    person.LoanForce__NMLS_Number__c == "" &&
    userData.settings.user.headshot
  ) {
    emailYOffset = 12;
  }

  let length = 0;
  let line = "";
  let lines = [];
  for (let i = 0; i < trimmedTitle.length; i++) {
    let testLine = line + trimmedTitle[i] + " ";
    let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
    if (testWidth > 100) {
      lines.push(line);
      line = trimmedTitle[i] + " ";
    } else {
      line = testLine;
    }
  }
  lines.push(line);

  for (let i = 0; i < lines.length; i++) {
    firstPage.drawText(`${lines[i]}`, {
      x: width - 235,
      y: titleHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    titleHeight -= 11;
  }

  textHeight = titleHeight - 1;

  if (person.LoanForce__NMLS_Number__c !== "") {
    firstPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: width - 235,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  firstPage.drawText(`O: ${person.Phone}`, {
    x: width - 235,
    y: textHeight,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.mobileNumber) {
    firstPage.drawText(`M: ${person.Mobile_Phone_Formatted__c}`, {
      x: width - 235,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  if (userData.settings.user.faxNumber) {
    firstPage.drawText(`F:  ${person.Fax}`, {
      x: width - 235,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  firstPage.drawText(`E: ${person.Email}`, {
    x: width - 235,
    y: textHeight - emailYOffset,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.customMloWebsite === true) {
    firstPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: width - 235,
      y: textHeight - emailYOffset,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    firstPage.drawText(
      `${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: width - 235,
        y: textHeight - emailYOffset,
        size: 10,
        font: minionFont,
        color: rgb(0, 0, 0),
      }
    );
    textHeight -= 12;
  }
  // console.log(userData.userData.mloHeadshotFinal);
  if (userData.userData.mloHeadshotFinal === "") {
    // console.log("no headshot");
  } else {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      firstPage.drawImage(headshot, {
        x: width - 123,
        y: 550,
        width: 80,
        height: 80,
      });
    }
  }
  // download the headshotImage

  // const pngUrl = userData.brand.whiteLogoUrl;
  const pngUrl = userData.brand.whiteLogoUrl;
  const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);

  let pngDims = pngImage.scale(0.6);

  if (userData.brand.BrandName === "Tabor Mortgage") {
    pngDims = pngImage.scale(0.7);
  }

  firstPage.drawImage(pngImage, {
    x: firstPage.getWidth() / 2 - pngDims.width / 2,
    y: firstPage.getHeight() - pngDims.height / 2 - 35,
    height: pngDims.height,
    width: pngDims.width,
  });

  /// CO BRANDING SECTION

  //
  //
  //
  //
  /// CO BRANDING SECTION

  let cobrandCompanyNameHeight = 449;
  let cobrandPhoneNumberHeight;
  let cobrandFaxNumberHeight = 425;
  let cobrandEmailHeight = 413;
  let cobrandWebsite = 401;

  if (enableCobranding && userData.settings.coBrand.firstName !== "") {
    firstPage.drawText(`${userData.settings.coBrand.firstName.toUpperCase()}`, {
      x: width - 235,
      y: 490,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    });
  }

  if (enableCobranding && userData.settings.coBrand.lastName !== "") {
    firstPage.drawText(`${userData.settings.coBrand.lastName.toUpperCase()}`, {
      x: width - 235,
      y: 475,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    });
  }
  const textWidthCompany = minionFont.widthOfTextAtSize(
    `${userData.settings.coBrand.companyName}`,
    10
  );
  const trimmedCompany = userData.settings.coBrand.companyName.split(" ");
  console.log(trimmedCompany);

  if (enableCobranding && userData.settings.coBrand.companyName !== "") {
    let length = 0;
    let line = "";
    let lines = [];
    for (let i = 0; i < trimmedCompany.length; i++) {
      let testLine = line + trimmedCompany[i] + " ";
      let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
      if (testWidth > 100) {
        lines.push(line);
        line = trimmedCompany[i] + " ";
      } else {
        line = testLine;
      }
    }
    lines.push(line);

    for (let i = 0; i < lines.length; i++) {
      firstPage.drawText(`${lines[i]}`, {
        x: width - 235,
        y: cobrandCompanyNameHeight,
        size: 10,
        font: minionFont,
        color: rgb(0.196, 0.196, 0.196),
      });
      cobrandCompanyNameHeight -= 11;
    }
  }

  if (
    (enableCobranding && userData.settings.coBrand.companyName !== "") ||
    userData.settings.coBrand.companyName !== null
  ) {
    cobrandPhoneNumberHeight = cobrandCompanyNameHeight - 1;
    cobrandFaxNumberHeight = cobrandCompanyNameHeight - 12;
    cobrandEmailHeight = cobrandCompanyNameHeight - 24;
    cobrandWebsite = cobrandCompanyNameHeight - 36;
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber === "") {
    cobrandEmailHeight = cobrandEmailHeight + 12;
    cobrandFaxNumberHeight = cobrandFaxNumberHeight + 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && userData.settings.coBrand.faxNumber === "") {
    cobrandWebsite = cobrandWebsite + 12;
    cobrandEmailHeight = cobrandEmailHeight + 12;
  }
  if (enableCobranding && userData.settings.coBrand.email === "") {
    cobrandFaxNumberHeight = cobrandFaxNumberHeight + 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && cobrandHeadshot) {
    cobrandEmailHeight = 401;
    cobrandWebsite = 389;
  }
  if (enableCobranding) {
    firstPage.drawRectangle({
      x: 377,
      y: 470,
      width: 100,
      height: 0.3,
      color: rgb(0.5, 0.5, 0.5),
    });
  }
  if (enableCobranding && userData.settings.coBrand.title !== "") {
    firstPage.drawText(`${userData.settings.coBrand.title}`, {
      x: width - 235,
      y: 460,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber !== "") {
    firstPage.drawText(`O: ${userData.settings.coBrand.phoneNumber}`, {
      x: width - 235,
      y: cobrandPhoneNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }
  if (enableCobranding && userData.settings.coBrand.faxNumber !== "") {
    firstPage.drawText(`M: ${userData.settings.coBrand.faxNumber}`, {
      x: width - 235,
      y: cobrandFaxNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.email !== "") {
    firstPage.drawText(`E: ${userData.settings.coBrand.email}`, {
      x: width - 235,
      y: cobrandEmailHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.website !== "") {
    firstPage.drawText(`${userData.settings.coBrand.website}`, {
      x: width - 235,
      y: cobrandWebsite,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && cobrandHeadshot) {
    const cobrandHeadshotUrl = cobrandHeadshot;
    // remove jpg from cobrandHeadshotUrl
    const cobrandHeadshotUrlNoJpg = cobrandHeadshotUrl.slice(0, -4);

    // console.log(cobrandHeadshotUrlNoJpg);
    const cobrandedFinal = cobrandHeadshotUrlNoJpg + ".png";
    // console.log(cobrandedFinal);
    const pngImageBytes3 = await fetch(cobrandedFinal).then((res) =>
      res.arrayBuffer()
    );
    const cobrandHeadshotimage = await pdfDoc.embedPng(pngImageBytes3);

    firstPage.drawImage(cobrandHeadshotimage, {
      x: width - 123,
      y: 420,
      width: 80,
      height: 80,
    });
  }

  /// Inner page section
  //
  //
  //
  //
  /// Inner page section

  const innerPages = pages.slice(1, pages.length - 1);
  console.log(innerPages, "inner pages");
  let imageSide = 1;
  innerPages.map((page) => {
    let { width, height } = page.getSize();
    if (userData.brand.hasHeader) {
      if (userData.brand.hasHeader) {
        page.drawRectangle({
          x: 0,
          y: height - 40,
          width: width,
          height: 40,
          color: headerColor,
        });
      }
    }

    pngDims = pngImage.scale(0.4);

    if (userData.brand.BrandName === "Tabor Mortgage") {
      pngDims = pngImage.scale(0.4);
    }

    if (imageSide % 2) {
      page.drawImage(pngImage, {
        x: 20,
        y: height - pngDims.height / 2 - 20,
        height: pngDims.height,
        width: pngDims.width,
      });
    } else {
      page.drawImage(pngImage, {
        x: width - pngDims.width - 15,
        y: height - pngDims.height / 2 - 20,
        height: pngDims.height,
        width: pngDims.width,
      });
    }
  });

  /// Content only pages
  //
  //
  //
  //
  /// Content only pages

  let textFontSize = 8;

  if (userData.flyerChoice.Spanish == true) {
    textFontSize = 7;
  }

  const contentPages = pages.slice(2, pages.length - 1);
  const ehoImageBytes = await fetch(
    "https://res.cloudinary.com/dqbckxsgm/image/upload/v1676057161/logos/EHO-Logo-Grey.png"
  ).then((res) => res.arrayBuffer());
  const EHOImage = await pdfDoc.embedPng(ehoImageBytes);

  contentPages.map((page) => {
    let { width, height } = page.getSize();

    page.drawText(`NMLS #${userData.branch.NMLS}`, {
      x: width - 554,
      y: 48,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    page.drawText(`${userData.branch.Address}`, {
      x: width - 420,
      y: 48,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });

    page.drawText(`${branchLicense}`, {
      x: width - 554,
      y: 40,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });

    // userData.brand.licensing break up into an array of words

    page.drawText(`${licensingLineOne}`, {
      x: width - 554,
      y: 32,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    page.drawText(`${licensingLineTwo}`, {
      x: width - 554,
      y: 24,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    page.drawText(`${licensingLineThree}`, {
      x: width - 554,
      y: 16,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });

    let reverseFLyer = userData.flyerChoice.name.includes("Reverse Mortgage");

    if (
      userData.brand.reverseLicensing !== "" &&
      userData.brand.reverseLicensing !== null &&
      userData.brand.reverseLicensing !== undefined &&
      reverseFLyer &&
      userData.flyerChoice.b2b
    ) {
      // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
      userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
        /BRAND_URL/g,
        userData.brand.WebsiteUrl
      );

      page.drawText(
        `${licensingLineFour} ${userData.brand.reverseLicensing} ${userData.flyerChoice.b2bLanguage}`,
        {
          x: width - 554,
          y: 8,
          size: textFontSize,
          font: arlianFont,
          color: rgb(0.196, 0.196, 0.196),
        }
      );
    } else if (
      userData.brand.reverseLicensing !== "" &&
      userData.brand.reverseLicensing !== null &&
      userData.brand.reverseLicensing !== undefined &&
      reverseFLyer
    ) {
      // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
      userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
        /BRAND_URL/g,
        userData.brand.WebsiteUrl
      );

      page.drawText(`${licensingLineFour} ${userData.brand.reverseLicensing}`, {
        x: width - 554,
        y: 8,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      });
    } else if (userData.flyerChoice.b2b) {
      page.drawText(
        `${licensingLineFour}  ${userData.flyerChoice.b2bLanguage}`,
        {
          x: width - 554,
          y: 8,
          size: textFontSize,
          font: arlianFont,
          color: rgb(0.196, 0.196, 0.196),
        }
      );
    } else {
      page.drawText(`${licensingLineFour} `, {
        x: width - 554,
        y: 8,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      });
    }

    page.drawText(`${contentPages.indexOf(page) + 3}`, {
      x: width - 30,
      y: 20,
      size: 19,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });

    let ehoDims = EHOImage.scale(0.35);
    page.drawImage(EHOImage, {
      x: width - 600,
      y: 17,
      height: ehoDims.height,
      width: ehoDims.width,
    });
  });

  /// Last Page Only
  //
  //
  //
  //
  /// Last Page Only

  const lastPage = pages[pages.length - 1];

  // Dimensions of the rectangle (bar)
  const barX = 0;
  const barY = 100;
  const barWidth = 612;
  const barHeight = 100;

  // Draw the rectangle (bar)
  lastPage.drawRectangle({
    x: barX,
    y: barY,
    width: barWidth,
    height: barHeight,
    color: headerColor,
  });

  // Scale the image
  let pngDims2 = pngImage.scale(0.7);

  // Calculate the center position for the image
  // This ensures the image is centered within the bar vertically
  const imageX = lastPage.getWidth() / 2 - pngDims2.width / 2;
  const imageY = barY + barHeight / 2 - pngDims2.height / 2;

  // Draw the image
  lastPage.drawImage(pngImage, {
    x: imageX,
    y: imageY,
    height: pngDims2.height,
    width: pngDims2.width,
  });

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    const link = document.createElement("a");
    link.href = url2;
    link.download = `${userData.flyerChoice.name}`;
    link.click();
  }
  await trackDownload(userData, userData.flyerChoice, enableCobranding);
  setLoading(false);
  return pdfBytes;
}

export default makeFlyerTemplateFour;
